import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpEventType }  from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/do';
import { GlobalDataService } from '../services/global-data.service';


@Injectable()
export class MyInterceptor implements HttpInterceptor{

	constructor(private global: GlobalDataService){}
	
	 intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
	
	let authtoken = localStorage.getItem('token');	
    const request = req.clone({
      setHeaders: { 
      			   Authorization: 'Bearer'+authtoken,
      			   'Content-Type' : 'application/json;',
      			   'X-Requested-With' : 'XMLHttpRequest'
      			  }
    });
    return next.handle(request).catch((error, caught) => {
		let str = "";
      // this.blocked = false;
   	   if (!error.error.errors) {
    		    str = error.error.message;
    		  }
      // this._display = false;
    	for (let item in error.error.errors) {
     	  str += "\n" + error.error.errors[item][0];
     	 }
		this.global.sendMessage(str);
		console.log(str+"   -asas");				
		if(error.status==498){
    						

							// this.http.get(this.httpUrl+'token',{headers: headers}).map((response: Response)=>{response.json()});

               					// this.global.refreshToken().subscribe(response=>{console.log(response); localStorage.setItem('token', response['token']);});
    					}		
						//intercept the respons error and displace it to the console
						console.log("Error Occurred");
						console.log(error.error.errors);
						//return the error to the method that called it
						return Observable.throw(error);
						});
  }

}




// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/utils/my-interceptor.ts